import { connectCurrentRefinements } from 'instantsearch.js/es/connectors';

let moreButtonClicked = false;

const renderSelectedFilters = (renderOptions, isFirstRender) => {
    const { items, refine, widgetParams } = renderOptions;
    const container = widgetParams.container;
    let allRefinements = [];
    items.forEach(item => {
        item.refinements.forEach(refinement => {
            allRefinements.push({
                attribute: item.attribute,
                label: `${item.label}: ${refinement.label}`,
                value: refinement.value,
                rawLabel: refinement.label,
            });
        });
    });

    const filterByContainer = document.querySelector('.filter-by-js');
    if (items.length === 0) {
        filterByContainer.classList.add('invisible');
    } else {
        filterByContainer.classList.remove('invisible');
    }

    allRefinements.sort((a, b) => a.rawLabel.localeCompare(b.rawLabel));

    container.innerHTML = `
        <div class="selected-filters flex flex-wrap fade-in">
            ${allRefinements.map(refinement => `
                <div class="refinement px-3 py-1.5 border text-sm md:text-base font-medium text-pxl-pine-tree w-fit flex items-center mb-3 mr-3">
                    ${refinement.value}
                    <button data-attribute="${refinement.attribute}" data-value="${refinement.value}" class="remove-filter text-pxl-pine-tree font-normal ml-2">x</button>
                </div>
            `).join('')}
            <div class="more-button bg-primary-orange text-white font-medium px-3 py-2 border w-fit text-nowrap mb-3 mr-3 ${moreButtonClicked ? 'hidden' : ''}">More <span class="font-normal">+</span></div>
        </div>
    `;

    const refinements = container.querySelectorAll('.refinement');
    const moreButton = container.querySelector('.more-button');
    const selectedFiltersContainer = container.querySelector('.selected-filters');

    const applyFilterVisibility = () => {
        selectedFiltersContainer.classList.remove('show');
        if (!moreButtonClicked) {
            let totalWidth = 0;
            const containerWidth = container.offsetWidth;
            let moreButtonWidth = moreButton.offsetWidth;

            refinements.forEach(refinement => refinement.classList.remove('hidden'));
            moreButton.classList.add('hidden');

            moreButton.classList.remove('hidden');
            moreButtonWidth = moreButton.offsetWidth;
            moreButton.classList.add('hidden');

            refinements.forEach((refinement, index) => {
                totalWidth += refinement.offsetWidth + parseFloat(window.getComputedStyle(refinement).marginRight);
                if (totalWidth + moreButtonWidth > containerWidth) {
                    refinement.classList.add('hidden');
                    moreButton.classList.remove('hidden');
                }
            });
        } else {
            refinements.forEach(refinement => refinement.classList.remove('hidden'));
        }
        selectedFiltersContainer.classList.add('show');
    };

    applyFilterVisibility();

    moreButton.addEventListener('click', () => {
        moreButtonClicked = true;
        refinements.forEach(refinement => refinement.classList.remove('hidden'));
        moreButton.classList.add('hidden');
    });

    container.querySelectorAll('.remove-filter').forEach(button => {
        button.addEventListener('click', event => {
            const attribute = event.currentTarget.getAttribute('data-attribute');
            const value = event.currentTarget.getAttribute('data-value');
            const itemToRefine = items.find(item => item.attribute === attribute && item.refinements.some(refinement => refinement.value === value));

            if (itemToRefine) {
                const refinementToRemove = itemToRefine.refinements.find(refinement => refinement.value === value);
                if (refinementToRemove) {
                    refine(refinementToRemove);
                }
            }
        });
    });

    window.addEventListener('resize', () => {
        selectedFiltersContainer.classList.remove('show');
        applyFilterVisibility();
    });
};

const SelectedFilters = connectCurrentRefinements(renderSelectedFilters);

export default SelectedFilters;
